module.exports = __webpack_public_path__ + "media/images/hitfun/icon.eye-5c242e7a70276d79e1ce60f79b9154c4.svg";